<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      @reload="getData()"
    >
      <div class="search-form" slot="header">
        <b-row class="mt-3">
          <div class="d-flex ml-3 pt_6">
            <div class="side-frame"></div>
            <div>
              <span style="font-size: 14px; color: #606266">
                {{ $l('tips_title_review_opinion') || '审批意见' }}
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: { amzFirstDemandCode: { type: String, default: '' } },
  data() {
    return { loading: false, tableData: [] }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzFirstDemandCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFirstDemandReviewListApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return

      const { data } = res.body || {}
      this.tableData = data || []
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
</style>
